import { render, staticRenderFns } from "./AnalyzeConceptAskRank.vue?vue&type=template&id=1c6584b0&scoped=true&"
import script from "./AnalyzeConceptAskRank.vue?vue&type=script&lang=ts&"
export * from "./AnalyzeConceptAskRank.vue?vue&type=script&lang=ts&"
import style0 from "./AnalyzeConceptAskRank.vue?vue&type=style&index=0&id=1c6584b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6584b0",
  null
  
)

export default component.exports